(ns common.schema.entities.investment-reservation
  (:require
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/single-ref-field :investment-reservation/type
                         "Investment reservation type"
                         [:entity.type/investment-reservation-type]
                         {:authorization su/access-user-user})

    (su/currency-field :investment-reservation/amount
                       "Amount"
                       {:authorization su/access-user-user})

    (su/date-field :investment-reservation/expiry-date
                   "Expiry date"
                   {:authorization su/access-user-user})

    (su/text-simple-field :investment-reservation/expiry-condition
                          "Expiry condition"
                          {:authorization su/access-user-user})

    (su/text-simple-field :investment-reservation/given-to
                          "Guarantee given to"
                          {:authorization su/access-user-user})

    (su/text-simple-field :investment-reservation/given-by
                          "Guarantee given by"
                          {:authorization su/access-user-user})

    (su/date-field :investment-reservation/void-date
                   "Void date"
                   {:authorization su/access-user-user})

    (su/single-ref-field :investment-reservation/voided-by
                         "Voided by"
                         [:entity.type/account]
                         {:authorization su/access-user-user})

    (su/text-multiline-field :investment-reservation/notes
                             "Notes"
                             {:authorization            su/access-user-user
                              :default-field-visibility :in-use})

    (su/calculated-field :investment-reservation/subtract-from-dry-powder
                         "Subtract from dry powder"
                         {:default-field-visibility :in-use
                          :data-type                :data.type/boolean
                          :composite-attrs          [:investment-reservation/type]
                          :calculation-triggers     {:entity.type/investment-reservation-type [[:investment-reservation/_type]]}
                          :calc-fn                  (fn [{:keys [entity-data entity-lookup tr]}]
                                                      (let [reservation-type (entity-lookup (:investment-reservation/type entity-data))
                                                            subtract? (when-not (:common/disabled? reservation-type)
                                                                        (:investment-reservation-type/subtract-from-dry-powder reservation-type))]
                                                        (if subtract?
                                                          (tr :yes)
                                                          (tr :no))))}))))


(def admin-configurable-fields
  #{:investment-reservation/amount
    :investment-reservation/expiry-date
    :investment-reservation/expiry-condition
    :investment-reservation/void-date
    :investment-reservation/voided-by
    :investment-reservation/given-to
    :investment-reservation/given-by})

; Referred in investment-reservation-type schema
(def admin-configurable-fields-options
  (->> schema
       (keep (fn [[field field-schema]]
               (when (some #{field} admin-configurable-fields)
                 (let [label (-> field-schema
                                 :field/translations
                                 :en)]
                   {:key   field
                    :label label}))))
       (vec)))
